// @ts-strict-ignore
import { ArticleDataService } from '@article/service/article-data.service';
import { Dictionary } from 'typescript-collections';
import { DrillingholePresetVO } from '../../../actions/drilling-hole/drilling-hole.vo';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DrillingHolePresetManager {
  private _drillingHolePresetByRailId: Dictionary<number, DrillingholePresetVO> = new Dictionary<number, DrillingholePresetVO>();

  constructor(private articleDataService: ArticleDataService) {}

  public getDrillingHolePresetByRailId(railId: number): Observable<DrillingholePresetVO> {
    if (!this.isDrillingHolePresetLoaded(railId)) {
      return this.loadDrillingHolePreset(railId);
    } else {
      return of(this._drillingHolePresetByRailId.getValue(railId));
    }
  }

  public isDrillingHolePresetLoaded(railId: number): boolean {
    return this._drillingHolePresetByRailId.containsKey(railId);
  }

  public loadDrillingHolePreset(railId: number): Observable<DrillingholePresetVO> {
    return this.articleDataService.loadDrillingholePresetByCarrierArticleId(railId).pipe(
      map((preset) => {
        this._drillingHolePresetByRailId.setValue(railId, preset);
        return preset;
      })
    );
  }
}
